import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Constants } from 'src/app/common/constants';
@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  private apiUrl = 'https://api.razorpay.com/v1/payments';
  private keyId = 'rzp_test_JI0uGG64CbnsV1';
  private keySecret = 'hN7qGnMKfTjZX0tTpETxyvx';
  private backendUrl = Constants.baseUrl;

  constructor(private http: HttpClient) {}

  getPaymentDetails(paymentId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Basic ' + btoa(`${this.keyId}:${this.keySecret}`)
    });

    return this.http.get(`${this.apiUrl}/${paymentId}`, { headers });
  }

  savePaymentDetails(paymentDetails: any): Observable<any> {
    return this.http.post(this.backendUrl, paymentDetails, { headers: { 'Content-Type': 'application/json' } });
  }
}
